/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DealRewardReelBusiness } from './DealRewardReelBusiness';
import {
    DealRewardReelBusinessFromJSON,
    DealRewardReelBusinessFromJSONTyped,
    DealRewardReelBusinessToJSON,
} from './DealRewardReelBusiness';
import type { DealRewardReelDeal } from './DealRewardReelDeal';
import {
    DealRewardReelDealFromJSON,
    DealRewardReelDealFromJSONTyped,
    DealRewardReelDealToJSON,
} from './DealRewardReelDeal';
import type { ReelDeal } from './ReelDeal';
import {
    ReelDealFromJSON,
    ReelDealFromJSONTyped,
    ReelDealToJSON,
} from './ReelDeal';

/**
 * 
 * @export
 * @interface DealRewardReel
 */
export interface DealRewardReel {
    /**
     * 
     * @type {number}
     * @memberof DealRewardReel
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof DealRewardReel
     */
    readonly name: string;
    /**
     * 
     * @type {DealRewardReelBusiness}
     * @memberof DealRewardReel
     */
    business: DealRewardReelBusiness;
    /**
     * 
     * @type {DealRewardReelDeal}
     * @memberof DealRewardReel
     */
    deal: DealRewardReelDeal;
    /**
     * 
     * @type {Array<ReelDeal>}
     * @memberof DealRewardReel
     */
    readonly deals: Array<ReelDeal>;
    /**
     * The ID of the reel associated with this reward. Corresponds to the YouTube video ID.
     * @type {string}
     * @memberof DealRewardReel
     */
    readonly reel_id: string;
    /**
     * The Mux playback ID for the video associated with this reward.
     * @type {string}
     * @memberof DealRewardReel
     */
    readonly mux_playback_id: string;
    /**
     * 
     * @type {string}
     * @memberof DealRewardReel
     */
    readonly mux_signed_video_token: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealRewardReel
     */
    readonly mux_signed_thumbnail_token: string | null;
}

/**
 * Check if a given object implements the DealRewardReel interface.
 */
export function instanceOfDealRewardReel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "business" in value;
    isInstance = isInstance && "deal" in value;
    isInstance = isInstance && "deals" in value;
    isInstance = isInstance && "reel_id" in value;
    isInstance = isInstance && "mux_playback_id" in value;
    isInstance = isInstance && "mux_signed_video_token" in value;
    isInstance = isInstance && "mux_signed_thumbnail_token" in value;

    return isInstance;
}

export function DealRewardReelFromJSON(json: any): DealRewardReel {
    return DealRewardReelFromJSONTyped(json, false);
}

export function DealRewardReelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DealRewardReel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'business': DealRewardReelBusinessFromJSON(json['business']),
        'deal': DealRewardReelDealFromJSON(json['deal']),
        'deals': ((json['deals'] as Array<any>).map(ReelDealFromJSON)),
        'reel_id': json['reel_id'],
        'mux_playback_id': json['mux_playback_id'],
        'mux_signed_video_token': json['mux_signed_video_token'],
        'mux_signed_thumbnail_token': json['mux_signed_thumbnail_token'],
    };
}

export function DealRewardReelToJSON(value?: DealRewardReel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'business': DealRewardReelBusinessToJSON(value.business),
        'deal': DealRewardReelDealToJSON(value.deal),
    };
}

